import { FAILURE_TYPES, FAILURE_NAMES } from '../../validationConstants';
import { ERROR_LOCALE_KEYS } from '../../../error/errorLocaleKeys';
import { isElementId } from '../../../uid/idValidator';

const ELEMENT_ID_ERROR_OBJECT = {
    name: FAILURE_NAMES.elementId,
    type: FAILURE_TYPES.ERROR,
    message: 'Not a valid elementId',
    errorLocaleKey: ERROR_LOCALE_KEYS.VALIDATION.ELEMENT_ID,
};

export default (fieldValue, validationConfig) => {
    if (!fieldValue) return;

    if (!isElementId(fieldValue)) return ELEMENT_ID_ERROR_OBJECT;

    return null;
};
